import { commonChecks } from '@xhs/ozone-detector';
export const isIOS = commonChecks.isIOS;
export const isAndroid = commonChecks.isAndroid;
export const isWeb = true;
